import React from "react";
import {
	Icon as ChakraIcon,
	ColorProps,
	SpaceProps,
	LayoutProps,
	BackgroundProps,
	BorderProps,
	IconProps as ChakraIconProps,
} from "@chakra-ui/react";

export type VariantTypes = "solid" | "regular" | "light" | "duotone";
export interface IconProps extends SpaceProps, ColorProps, LayoutProps, BackgroundProps, BorderProps, ChakraIconProps {
	variant?: VariantTypes;
	icon: string;
	boxSize?: string | number;
}

const variantToFontAwesomeStyle = {
	solid: "fas",
	regular: "fas",
	light: "fal",
	duotone: "fad",
};

export const FZCLIcon = ({ variant = "regular", icon, ...props }: IconProps): JSX.Element => {
	return (
		<ChakraIcon {...props}>
			<i className={`${variantToFontAwesomeStyle[variant]} ${icon}`} />
		</ChakraIcon>
	);
};
